import { render } from "./Layout1.vue.js?vue&type=template&id=b0a3a8c2!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Layout1.vue?vue&type=template&id=b0a3a8c2"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__